/* unplugin-vue-components disabled */import { render } from "./source-wrap.vue?vue&type=template&id=42ffeaf6&scoped=true"
import script from "./source-wrap.vue?vue&type=script&lang=js"
export * from "./source-wrap.vue?vue&type=script&lang=js"

import "./source-wrap.vue?vue&type=style&index=0&id=42ffeaf6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ffeaf6"],['__file',"src/components/sources/source-wrap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42ffeaf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42ffeaf6', __exports__)) {
    api.reload('42ffeaf6', __exports__)
  }
  
  module.hot.accept("./source-wrap.vue?vue&type=template&id=42ffeaf6&scoped=true", () => {
    api.rerender('42ffeaf6', render)
  })

}


export default __exports__